// AI (Claude) w aplikacji jest WSTRZYMANE do odwołania (config.ai.enabledByDefault = false): bez niego nie ma paska „Zapytaj bota”, reakcji modelu ani rozmowy.
// Do testów (i do późniejszego włączenia bez nowej wersji) wystarczy w przeglądarce klucz `naative.ai.v1` = "on" (albo "off").
import { config } from '../config.ts';
import type { StorageLike } from './attemptLog.ts';

export const AI_KEY = 'naative.ai.v1';

export function aiEnabled(store: Pick<StorageLike, 'getItem' | 'setItem'> | null, fallback: boolean = config.ai.enabledByDefault): boolean {
  try {
    const raw = store?.getItem(AI_KEY);
    if (raw === 'on') return true;
    if (raw === 'off') return false;
  } catch {
    /* brak dostępu do pamięci — wartość domyślna */
  }
  return fallback;
}
